import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Chip, Button } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import * as Var from "../../styles/variables";
import { setPeriodType } from "../../actions";
import * as H from "../../utils/helper";
import TepcoConfig from "../../config/TepcoConfig";
import TagConfig from "../../config/TagConfig";
import { SAITAMA_INSPECTION_FILTER_ITEMS } from "../../config/SaitamaInspectionItems";
import { isSaitamaSeasonSelected } from "../../config/SaitamaCityConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      fontSize: 12,
      color: "#484848",
    },
    filterTitle: {
      fontSize: 14,
      color: "#484848",
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
      color: Var.btnLabelColor,
    },
    filterItem: {
      marginTop: theme.spacing(1),
    },
  })
);

const getAssetTypeName = (assetType) => {
  switch(assetType) {
    case "POWER_POLE":
      return "電柱（全て）";
    case "POWER_POLE_HAS_PROTECTIVE_TUBE_ALL":
      return "電柱（防護管付き・全て電柱（防護管付き・全て）";
    case "POWER_POLE_HAS_PROTECTIVE_TUBE_WITH_PIC":
      return "電柱（防護管付き・写真あり）";
    case "MAN_HOLE":
      return "マンホール";
    case "HAND_HOLE":
      return "ハンドホール";
    case "GRATING":
      return "換気口";
    case "GROUND_EQUIPMENT-MS":
      return "地上設備 MS";
    case "GROUND_EQUIPMENT-PM":
      return "地上設備 PM";
    case "POWER_POLE_HAS_PLNAT":
      return "電柱（ツルツタ台帳記載）";
    case "POWER_POLE_HAS_INSULATE_SWITCH":
      return "電柱（高圧設備あり）";
    case "POWER_POLE_HAS_PLNAT_AND_INSULATE_SWITCH":
      return "電柱（ツルツタ台帳記載・高圧）";
    case "POWER_POLE_NO_INSULATE_SWITCH":
      return "電柱（高圧設備なし）";
    default:
      break;
  }
}

const nttGetAssetTypeName = (assetType) => {
  switch(assetType) {
    case "CONCRETE":
      return "メーカー調査（すべて）";
    case "CONCRETE_LUCKY":
      return "メーカー調査（２段階判定対象）";
    case "CONCRETE_REGULAR":
      return "メーカー調査（２段階判定対象外）";
    case "STEEL":
      return "地際調査（すべて）";
    case "STEEL_LUCKY":
      return "地際調査（２段階判定対象）";
    case "STEEL_REGULAR":
      return "地際調査（２段階判定対象外）";
    case "TARGET_LUCKY":
      return "2段階判定対象";
    case "TARGET_REGULAR":
      return "2段階判定対象外";
    case "all":
      return "全て";
    default:
      return "-";
  }
}

const getReviewStatusName = (reviewStatus) =>
  reviewStatus === "REJECTED" ? "NG" : "OK";

const FilterApplied = ({
  companyName,
  selectedSeason,
  setPeriodType,
  filteredTotal,
  filteredTotalReport,
  filterStore,
  reportFilterStore,
  reportTagFilterData,
  filterType,
  filterStoreNtt,
  reportFilterStoreNtt,
  filterStoreHokuden,
  filterHokuden,
  reportFilterStoreHokuden,
  hokudenOptionCity,
  commonReportFilterOptions,
  showReportDownloadButton,
  onReportDownload,
  isReportDownloadDisabled,
  showRemovalRequestDownloadButton,
  onRemovalRequestDownload,
  isRemovalRequestDownloadDisabled,
  showBirdNestRewardDownloadButton,
  onBirdNestRewardDownload,
  isBirdNestRewardDownloadDisabled,
}) => {
  const classes = useStyles();
  const isMitsubishi = companyName === "mitsubishi";
  const [assetTypeSel, setAssetTypeSel] = useState("全て");
  const signNumberValue = filterType === "report"
    ? reportFilterStore.signNumber === null ? "全て" : reportFilterStore.signNumber
    : filterStore.signNumber === null ? "全て" : filterStore.signNumber;
  const assetValue = filterType === "report"
    ? reportFilterStore.assetId === null ? "全て" : reportFilterStore.assetId
    : filterStore.assetId === null ? "全て" : filterStore.assetId;
  const assetTypeValue = filterStore.assetType === "all" && filterStore.assetType === "MISSION_ASSET"
    ? "全て" : getAssetTypeName(filterStore.assetType);
  const reviewStatusValue = filterStore.reviewStatus === "REJECTED" ? "NG" : "OK";
  const reviewStatusNttValue = getReviewStatusName(filterStoreNtt.reviewStatus);
  const reviewStatusHokudenValue = getReviewStatusName(filterStoreHokuden.reviewStatus);
  const [manageGroupSel, setManageGroupSel] = useState("全て");
  const sortPrefix = filterType === "photo" ? "撮影日時" : "報告日時";
  const sortValue = filterType === "report"
    ? reportFilterStore.order === "desc"
      ? `${sortPrefix} - 降順`
      : `${sortPrefix}  - 昇順`
    : filterStore.type === "occurred_datetime" && filterStore.order === "desc"
      ? `${sortPrefix} - 降順`
      : `${sortPrefix}  - 昇順`;
  const filterTotalNumber = filterType === "report" ? filteredTotalReport : filteredTotal;
  const reportTimeValue = reportFilterStore.reportTime == "all"
    ? "全て"
    : reportFilterStore.reportTime === "1"
      ? "初回"
      : `${reportFilterStore.reportTime}回目以降`;
  const playerIdValue = reportFilterStore.playerId ? reportFilterStore.playerId : "全て";
  const saitamaManagementId = filterStore.managementId || "全て";
  const saitamaInspectionValue = Array.isArray(filterStore.inspectionItems) && filterStore.inspectionItems.length > 0
    ? filterStore.inspectionItems
      .map((code) => SAITAMA_INSPECTION_FILTER_ITEMS.find((item) => item.code === code)?.label || code)
      .join("、")
    : "全て";
  const saitamaFirstCaptureValue = filterStore.firstCaptureOnly ? "ON" : "OFF";
  const saitamaSortValue = filterStore.order === "asc" ? "撮影日時・昇順" : "撮影日時・降順";
  const saitamaReportManagementId = reportFilterStore.managementId || "全て";
  const saitamaReportTagValue = Array.isArray(reportFilterStore.tag) && reportFilterStore.tag.length > 0
    ? reportFilterStore.tag.map((value) => (
      (reportTagFilterData || []).find((option) => option.value === value)?.label || value
    )).join("、")
    : "全て";
  const saitamaReportPlayerId = reportFilterStore.playerId || "全て";
  const saitamaReportSortValue = reportFilterStore.order === "asc" ? "報告日時・昇順" : "報告日時・降順";

  // NTT用のフィルター
  const [prefecturalArea, setPrefecturalArea] = useState("全て");
  const [exchangeOfficeName, setExchangeOfficeName] = useState("全て");
  const [assetInfo, setAssetInfo] = useState("全て");
  const [photographyTarget, setPhotographyTarget] = useState("全て");
  const [photoType, setPhotoType] = useState("全て");
  const [twoStepVerification, setTwoStepVerification] = useState("全て");
  const [resultTag, setResultTag] = useState("全て");
  const [nttSort, setNttSort] = useState("降順");

  // hokuden用のフィルター
  const [powerAssetNumber, setPowerAssetNumber] = useState("全て");
  const [municipality, setMunicipality] = useState("全て");
  const [branchName, setBranchName] = useState("全て");
  const [username, setUsername] = useState("全て");
  const [hokudenSort, setHokudenSort] = useState("降順");

  useEffect(() => {
    const asv = filterStore.assetType === "all" || filterStore.assetType === "MISSION_ASSET"
    ? "全て" : getAssetTypeName(filterStore.assetType);
    setAssetTypeSel(asv);
  }, [filterStore.assetType]);

  useEffect(() => {
    const asv = reportFilterStore.assetType === "all" || reportFilterStore.assetType === "MISSION_ASSET"
    ? "全て" : getAssetTypeName(reportFilterStore.assetType);
    setAssetTypeSel(asv);
  }, [reportFilterStore.assetType]);

  useEffect(() => {
    const manageGroupValue = filterStore.manageGroup.key === "all"
    ? "全て" : TepcoConfig.manageGroupLabel[filterStore.manageGroup.key];
    setManageGroupSel(manageGroupValue);
  }, [filterStore.manageGroup]);

  useEffect(() => {
    const manageGroupValue = reportFilterStore.manageGroup.key === "all"
    ? "全て" : TepcoConfig.manageGroupLabel[reportFilterStore.manageGroup.key];
    setManageGroupSel(manageGroupValue);
  }, [reportFilterStore.manageGroup]);

  useEffect(() => {
    const photoTypeValue = nttGetAssetTypeName(filterStoreNtt.photoType);
    setPhotoType(photoTypeValue);
    const twoStepVerificationValue = filterStoreNtt.twoStepVerification === "target"
      ? "対象" : filterStoreNtt.twoStepVerification === "non-target" ? "対象外" : "全て";
    setTwoStepVerification(twoStepVerificationValue);
    const resultTagMap ={
      true: "合格",
      false: "不合格",
      pending: "保留",
      unchecked: "未確認",
    };
    setResultTag(resultTagMap[filterStoreNtt.resultTag] ?? "全て");

    const prefecturalAreaValue = filterStoreNtt.prefecturalArea === "all"
      ? "全て" : filterStoreNtt.prefecturalArea;
    setPrefecturalArea(prefecturalAreaValue);

    const exchangeOfficeNameValue = filterStoreNtt.exchangeOfficeName === "all"
      ? "全て" : filterStoreNtt.exchangeOfficeName;
    setExchangeOfficeName(exchangeOfficeNameValue);

    const assetInfoValue = filterStoreNtt.assetInfo === "all"
     ? "全て" : filterStoreNtt.assetInfo;
    setAssetInfo(assetInfoValue);

    const photographyTargetValue = filterStoreNtt.photographyTarget === "all"
      ? "全て" : filterStoreNtt.photographyTarget;
      setPhotographyTarget(photographyTargetValue);

    const nttSortValue = filterStoreNtt.order === "desc" ? "降順" : "昇順";
    setNttSort(nttSortValue);
  }, [filterStoreNtt]);

  useEffect(() => {
    const photoTypeValue = nttGetAssetTypeName(reportFilterStoreNtt.photoType);
    setPhotoType(photoTypeValue);
    const twoStepVerificationValue = reportFilterStoreNtt.twoStepVerification === "target"
      ? "対象" : reportFilterStoreNtt.twoStepVerification === "non-target" ? "対象外" : "全て";
    setTwoStepVerification(twoStepVerificationValue);
    const resultTagValue = reportFilterStoreNtt.resultTag === "true"
    ? "合格" : reportFilterStoreNtt.resultTag === "false" ? "不合格" : reportFilterStoreNtt.resultTag === "pending" ? "保留" : "全て";
    setResultTag(resultTagValue);
    const prefecturalAreaValue = reportFilterStoreNtt.prefecturalArea === "all"
      ? "全て" : reportFilterStoreNtt.prefecturalArea;
    setPrefecturalArea(prefecturalAreaValue);
    const exchangeOfficeNameValue = reportFilterStoreNtt.exchangeOfficeName === "all"
      ? "全て" : reportFilterStoreNtt.exchangeOfficeName;
    setExchangeOfficeName(exchangeOfficeNameValue);

    const assetInfoValue = reportFilterStoreNtt.assetInfo === "all"
      ? "全て" : reportFilterStoreNtt.assetInfo;
      setAssetInfo(assetInfoValue);

    const photographyTargetValue = reportFilterStoreNtt.photographyTarget === "all"
      ? "全て" : reportFilterStoreNtt.photographyTarget;
      setPhotographyTarget(photographyTargetValue);
  }, [reportFilterStoreNtt]);

  // hokuden
  useEffect(() => {
    setPowerAssetNumber(filterStoreHokuden.powerAssetNumber === null
      ? "全て" : filterStoreHokuden.powerAssetNumber);
    const selectedCityOption = hokudenOptionCity.find(
        (option) => option.value === filterStoreHokuden.municipality
      );
    setMunicipality(
      filterStoreHokuden.municipality === "all"
        ? "全て"
        : selectedCityOption?.label || filterStoreHokuden.municipality
    );
    setBranchName(filterStoreHokuden.branchName === "all"
      ? "全て" : filterStoreHokuden.branchName);
    setUsername(filterStoreHokuden.username === "all"
      ? "全て" : filterStoreHokuden.username);
    const hokudenSortValue = filterStoreHokuden.order === "desc" ? "降順" : "昇順";
    setHokudenSort(hokudenSortValue);
  }, [filterStoreHokuden]);

  useEffect(() => {
    setPowerAssetNumber(filterHokuden.powerAssetNumber === null
      ? "全て" : filterHokuden.powerAssetNumber);
    const selectedCityOption = hokudenOptionCity.find(
        (option) => option.value === filterHokuden.municipality
      );
    setMunicipality(
      filterHokuden.municipality === "all"
        ? "全て"
        : selectedCityOption?.label || filterHokuden.municipality
    );
    setBranchName(filterHokuden.branchName === "all"
      ? "全て" : filterHokuden.branchName);
    setUsername(filterHokuden.username === "all"
      ? "全て" : filterHokuden.username);
    const hokudenSortValue = filterHokuden.order === "desc" ? "降順" : "昇順";
    setHokudenSort(hokudenSortValue);
  }, [filterHokuden]);

  const renderContent = () => {
    const birdNestStatusLabel = reportFilterStore.reportStatus
      ? (reportFilterStore.reportStatus === "unselected"
        ? "未選択"
        : (TagConfig.tepcoBirdNestStatusOption.find(
            (status) => status.value.toString() === reportFilterStore.reportStatus.toString(),
          )?.label || reportFilterStore.reportStatus))
      : "全て";
    const birdNestRemovedLabel = reportFilterStore.reportRemoved ? "撤去済みのみ" : "全て";
    const birdNestResetLabel = reportFilterStore.reportReset ? "未完了のみ" : "-";
    const commonMunicipality = Array.isArray(reportFilterStore.municipality) && reportFilterStore.municipality.length > 0
      ? reportFilterStore.municipality : "全て";
    const commonPrefecture = Array.isArray(reportFilterStore.prefecture) && reportFilterStore.prefecture.length > 0
      ? reportFilterStore.prefecture : "全て";
    const commonUsername = reportFilterStore.username && reportFilterStore.username !== "all"
      ? reportFilterStore.username : "全て";
    const commonAssetTypeValues = Array.isArray(reportFilterStore.assetType)
      ? reportFilterStore.assetType
      : reportFilterStore.assetType && reportFilterStore.assetType !== "all" ? [reportFilterStore.assetType] : [];
    const commonAssetType = commonAssetTypeValues.length > 0
      ? commonAssetTypeValues.map((value) =>
        (commonReportFilterOptions.assetType || []).find((option) => option.value === value)?.label || value
      ).join("、")
      : "全て";
    if (companyName === "saitama-city" ||
      isSaitamaSeasonSelected(localStorage.getItem("access_key"), selectedSeason)) return (
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.filtered}
      >
        {filterType === "photo" && (
          <Grid item className={classes.filterItem}>
            <span className={classes.filterTitle}>管理ID</span>：{saitamaManagementId}&nbsp;&nbsp;｜&nbsp;&nbsp;
            <span className={classes.filterTitle}>点検項目</span>：{saitamaInspectionValue}&nbsp;&nbsp;｜&nbsp;&nbsp;
            <span className={classes.filterTitle}>初回撮影のみ</span>：{saitamaFirstCaptureValue}&nbsp;&nbsp;｜&nbsp;&nbsp;
            <span className={classes.filterTitle}>ソート</span>：{saitamaSortValue}
          </Grid>
        )}
        {filterType === "report" && (
          <Grid item className={classes.filterItem}>
            <span className={classes.filterTitle}>管理ID</span>：{saitamaReportManagementId}&nbsp;&nbsp;｜&nbsp;&nbsp;
            <span className={classes.filterTitle}>報告タグ</span>：{saitamaReportTagValue}&nbsp;&nbsp;｜&nbsp;&nbsp;
            <span className={classes.filterTitle}>Player ID</span>：{saitamaReportPlayerId}&nbsp;&nbsp;｜&nbsp;&nbsp;
            <span className={classes.filterTitle}>ソート</span>：{saitamaReportSortValue}
          </Grid>
        )}
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>件数</span>：
          {H.FormatNumber.formatCommaThousand(filterTotalNumber)}
        </Grid>
      </Grid>
    );
    if (companyName === "common") return (
      <Grid container direction="column" justifyContent="space-between" className={classes.filtered}>
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>自治体名</span>： {Array.isArray(commonMunicipality) ? commonMunicipality.join("、") : commonMunicipality}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>都道府県</span>： {Array.isArray(commonPrefecture) ? commonPrefecture.join("、") : commonPrefecture}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>アセットタイプ</span>： {commonAssetType}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>報告者</span>： {commonUsername}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>Player ID</span>： {playerIdValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>ソート</span>： {sortValue}
        </Grid>
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>報告タグ</span>：
          {reportFilterStore.tag.length > 0 ? reportFilterStore.tag.map((option, index) => (
            <Chip key={index} size="small" label={option} style={{ backgroundColor: "#f3ee91", color: "black", marginRight: 5 }} />
          )) : "全て"}
        </Grid>
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>件数</span>：
          {H.FormatNumber.formatCommaThousand(filterTotalNumber)}
        </Grid>
      </Grid>
    );
    if (companyName === "tepco") return (
      <>
      <Grid
        container
        direction="column"
        justifyContent={"space-between"}
        className={classes.filtered}
      >
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>標識番号</span>： {signNumberValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>設備番号</span>： {assetValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>アセットタイプ</span>： {assetTypeSel}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>配電保守グループ</span>： {manageGroupSel}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          {filterType !== "report" &&
            <><span className={classes.filterTitle}>レビュー結果</span>： {reviewStatusValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>
          }
          {filterType === "report" &&
            <><span className={classes.filterTitle}>撮影回数</span>： {reportTimeValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>
          }
          {filterType === "report" &&
            <><span className={classes.filterTitle}>Player ID</span>： {playerIdValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>
          }
          <span className={classes.filterTitle}>ソート</span>： {sortValue}
        </Grid>
        {filterType === "report" &&
        <>
          <Grid
            container
            direction="row"
            justifyContent={"space-between"}
            className={classes.filtered}
          >
            <Grid item className={classes.filterItem} lg={6}>
              <span className={classes.filterTitle}>報告タグ</span>：
              {reportFilterStore.tag.length > 0 ? (
                reportFilterStore.tag.map((option, index) => (
                  <Chip
                    key={index}
                    size="small"
                    label={option}
                    style={{
                      backgroundColor: '#f3ee91',
                      color: 'black',
                      paddingTop: 0,
                      marginRight: 5,
                    }}
                  />
                ))
              ) : (
                "全て"
              )}
            </Grid>
            <Grid item className={classes.filterItem} lg={6}>
              <span className={classes.filterTitle}>報告確認結果</span>：
              {reportFilterStore.tagResult.length > 0 ? (
                reportFilterStore.tagResult.map((option, index) => (
                  <Chip
                    key={index}
                    size="small"
                    label={option}
                    style={{
                      backgroundColor: '#f3ee91',
                      color: 'black',
                      paddingTop: 0,
                      marginRight: 5,
                    }}
                  />
                ))
              ) : (
                "全て"
              )}
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent={"space-between"}
            className={classes.filtered}
          >
            <Grid item className={classes.filterItem} lg={6}>
              <span className={classes.filterTitle}>営巣報告ステータス</span>：
              {reportFilterStore.reportStatus ? (
                <Chip
                  size="small"
                  label={birdNestStatusLabel}
                  style={{
                    backgroundColor: "#f3ee91",
                    color: "black",
                    paddingTop: 0,
                    marginRight: 5,
                  }}
                />
              ) : (
                "全て"
              )}
            </Grid>
            <Grid item className={classes.filterItem} lg={6}>
              <span className={classes.filterTitle}>営巣撤去済み</span>：
              {reportFilterStore.reportRemoved ? (
                <Chip
                  size="small"
                  label={birdNestRemovedLabel}
                  style={{
                    backgroundColor: "#f3ee91",
                    color: "black",
                    paddingTop: 0,
                    marginRight: 5,
                  }}
                />
              ) : (
                "-"
              )}
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent={"space-between"}
            className={classes.filtered}
          >
            <Grid item className={classes.filterItem} lg={6}>
              <span className={classes.filterTitle}>営巣撤去リセットステータス</span>：
              {reportFilterStore.reportReset ? (
                <Chip
                  size="small"
                  label={birdNestResetLabel}
                  style={{
                    backgroundColor: "#f3ee91",
                    color: "black",
                    paddingTop: 0,
                    marginRight: 5,
                  }}
                />
              ) : (
                "-"
              )}
            </Grid>
          </Grid>
        </>
        }
        <Grid item className={classes.filterItem} xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <Grid item>
              <span className={classes.filterTitle}>件数</span>：
              {H.FormatNumber.formatCommaThousand(filterTotalNumber)}
            </Grid>
            <Grid item style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
              {filterType === "report" && showRemovalRequestDownloadButton && (
                <Button
                  variant="contained"
                  onClick={onRemovalRequestDownload}
                  disabled={isRemovalRequestDownloadDisabled}
                  startIcon={<GetAppIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                >
                  営巣除去依頼CSV
                </Button>
              )}
              {filterType === "report" && showBirdNestRewardDownloadButton && (
                <Button
                  variant="contained"
                  onClick={onBirdNestRewardDownload}
                  disabled={isBirdNestRewardDownloadDisabled}
                  startIcon={<GetAppIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                >
                  営巣報告レビュー結果CSV
                </Button>
              )}
              {filterType === "report" && showReportDownloadButton && (
                <Button
                  variant="contained"
                  onClick={onReportDownload}
                  disabled={isReportDownloadDisabled}
                  startIcon={<GetAppIcon fontSize="small" />}
                >
                  報告データ一括CSV
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>);
    if (companyName.includes("ntt") || companyName === "okiden") return (<>
      <Grid
        container
        direction="column"
        justifyContent={"space-between"}
        className={classes.filtered}
      >
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>県域</span>： {prefecturalArea}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>収容局名</span>： {exchangeOfficeName}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          {(companyName === "ntt-ft" || companyName === "okiden") &&
            <>
            <span className={classes.filterTitle}>電柱識別番号</span>： {assetInfo}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            <span className={classes.filterTitle}>撮影対象</span>： {photographyTarget}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            </>
          }
          {(companyName !== "ntt-ft" && companyName !== "okiden") &&
            <><span className={classes.filterTitle}>撮影種別</span>： {photoType}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>
          }
          {filterType !== "report" &&
            <><span className={classes.filterTitle}>レビュー結果</span>： {reviewStatusNttValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>
          }
          {filterType !== "report" &&
            <>
            <span className={classes.filterTitle}>
              {companyName === "ntt" ? "ME判定結果" : "判定結果"}
            </span>： {resultTag}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            </>
          }
          <span className={classes.filterTitle}>ソート</span>： {nttSort}
        </Grid>
        {filterType === "report" &&
          <Grid item className={classes.filterItem}>
            <span className={classes.filterTitle}>報告タグ</span>：
            {reportFilterStoreNtt.tag.length > 0 ? (
              reportFilterStoreNtt.tag.map((option, index) => (
                <Chip
                  key={index}
                  size="small"
                  label={option}
                  style={{
                    backgroundColor: '#f3ee91',
                    color: 'black',
                    paddingTop: 0,
                    marginRight: 5,
                  }}
                />
              ))
            ) : (
              "全て"
            )}
          </Grid>
        }
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>件数</span>：
          {H.FormatNumber.formatCommaThousand(filterTotalNumber)}
        </Grid>
      </Grid>
    </>);
    if (companyName === "hokuden") return (<>
      <Grid
        container
        direction="column"
        justifyContent={"space-between"}
        className={classes.filtered}
      >
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>電柱番号</span>： {powerAssetNumber}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          {/* <span className={classes.filterTitle}>エリア名</span>： {exchangeOfficeName}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp; */}
          <span className={classes.filterTitle}>市町村名</span>： {municipality}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>支店コード</span>： {branchName}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          <span className={classes.filterTitle}>撮影者</span>： {username}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          {filterType !== "report" &&
            <><span className={classes.filterTitle}>レビュー結果</span>： {reviewStatusHokudenValue}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</>
          }
          <span className={classes.filterTitle}>ソート</span>： {hokudenSort}
        </Grid>
        {filterType === "report" &&
          <Grid item className={classes.filterItem}>
            <span className={classes.filterTitle}>報告タグ</span>：
            {reportFilterStoreHokuden.tag.length > 0 ? (
              reportFilterStoreHokuden.tag.map((option, index) => (
                <Chip
                  key={index}
                  size="small"
                  label={option}
                  style={{
                    backgroundColor: '#f3ee91',
                    color: 'black',
                    paddingTop: 0,
                    marginRight: 5,
                  }}
                />
              ))
            ) : (
              "全て"
            )}
          </Grid>
        }
        <Grid item className={classes.filterItem}>
          <span className={classes.filterTitle}>件数</span>：
          {H.FormatNumber.formatCommaThousand(filterTotalNumber)}
        </Grid>
      </Grid>
    </>);
    return null;
  };

  return (
    <>
      {!isMitsubishi && <div className={classes.title}>適用絞り込み条件</div>}
      {isMitsubishi ? (
        <Grid
          container
          direction="column"
          justifyContent={"space-between"}
          className={classes.filtered}
        >
          <Grid item className={classes.filterItem}>
            <span className={classes.filterTitle}>件数</span>：
            {H.FormatNumber.formatCommaThousand(filterTotalNumber)}
          </Grid>
        </Grid>
      ) : (
        renderContent()
      )}
    </>
  );
};

FilterApplied.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  filteredTotal: state.home.filteredTotal,
  filteredTotalReport: state.report.filteredTotal,
  filterStore: state.home.filter,
  reportFilterStore: state.report.filter,
  reportTagFilterData: state.report.reportTagFilterData,
  filterType: state.app.filterType,
  filterStoreNtt: state.home.filterNtt,
  reportFilterStoreNtt: state.report.filterNtt,
  filterStoreHokuden: state.home.filterHokuden,
  filterHokuden: state.report.filterHokuden,
  reportFilterStoreHokuden: state.report.filterHokuden,
  hokudenOptionCity: state.home.hokudenOptionCity,
  commonReportFilterOptions: state.report.commonReportFilterOptions,
  selectedSeason: state.app.selectedSeason,
});

const mapDispatchToProps = (dispatch) => ({
  setPeriodType: (param) => dispatch(setPeriodType(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(FilterApplied));
